export default __webpack_public_path__ + "static/media/bccfd3643b5fc57c600ae2ee38cb3cad.png";